import React from "react";
import Paper from "@material-ui/core/Paper";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

class UserList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  render() {
    let items = this.props.items.map(item => {
      return (
        <ListItem
          key={item._id}
          onClick={e => {
            this.props.handleEdit(item);
          }}
        >
          <ListItemText primary={item.firstname + ' ' + item.lastname} secondary={item.type === 1 ? 'Personeel' : (item.type === 2 ? 'Uitzendkracht' : (item.type===3 ? 'ZZP-er':''))} />
        </ListItem>
      );
    });

    return (
      <div>
        <Paper>
          <List>{items}</List>
        </Paper>
      </div>
    );
  }
}
export default UserList;
